document.addEventListener('DOMContentLoaded', function () {
  initKeyFeaturesAccordion(document);
});

document.addEventListener('shopify:section:load', function (event) {
  initKeyFeaturesAccordion(event.target);
});

function initKeyFeaturesAccordion(scope) {
  var sections = scope.querySelectorAll('.ss-key-features');

  sections.forEach(function (section) {
    if (section.dataset.kfInit === 'true') return;
    section.dataset.kfInit = 'true';

    var items = section.querySelectorAll('[data-feature-item]');

    items.forEach(function (item) {
      item.addEventListener('click', function () {
        if (window.innerWidth > 749) return;
        toggleAccordion(items, item);
      });

      item.addEventListener('keydown', function (event) {
        if (window.innerWidth > 749) return;

        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          toggleAccordion(items, item);
        }
      });
    });
  });
}

function toggleAccordion(items, currentItem) {
  var isOpen = currentItem.classList.contains('is-open');

  items.forEach(function (item) {
    item.classList.remove('is-open');
    item.setAttribute('aria-expanded', 'false');
  });

  if (!isOpen) {
    currentItem.classList.add('is-open');
    currentItem.setAttribute('aria-expanded', 'true');
  }
}